import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useCallback } from 'react'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { useNavigate } from 'react-router'
import { customerTypes } from '@teinor/erp/types/company/customer/customerTypes'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam } from '../../../../../../../../../../utils/reducers/getters'
import locations from '../../../../../../../../../../utils/globals/locations'


interface ModalContactB2BChangeTypeProps extends ModalContactB2BChangeTypeLogicProps { }

const ModalContactB2BChangeType: React.FC<ModalContactB2BChangeTypeProps> = ({ ...rest}) => {
    const {t} = useTwinTranslation()
    const {handleOnSubmitContactType} = useModalContactB2BChangeTypeLogic({ ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={rest.setOpened} onAccept={handleOnSubmitContactType} translations={{
            title: t('transformToCustomerB2B', 'Transformar a cliente B2B'),
            subtitle: t('sureTransformContactToCustomerB2B', '¿Seguro que quieres transformar este Cliente Potencial a Cliente B2B?'),
            buttonAccept: t('transform', 'Transformar')
        }} />
    )
}

interface ModalContactB2BChangeTypeLogicProps extends ModalEditComponentProps {}

const useModalContactB2BChangeTypeLogic = ({ allRowData, onSubmit }: ModalContactB2BChangeTypeLogicProps) => {
    const navigate = useNavigate()
    
    const handleOnSubmitContactType = useCallback(async () => {
        const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false
        const result = await twinFetchPostJSON('/api/app/customer/updateCustomer', {
            id: allRowData?.id,
            customer_type: customerTypes['B2B']
        })
        if (result) {
            navigate(locations.customer + '/' + (showAllCustomersTogether ? 'allCustomers' : 'customersB2B') + '/' + allRowData?.id + '/main')
            onSubmit(result, {})
        }
    }, [allRowData?.id, navigate, onSubmit])

    return { handleOnSubmitContactType }
}


export default ModalContactB2BChangeType